import { render, staticRenderFns } from "./FormErrors.vue?vue&type=template&id=6b366b24&scoped=true"
import script from "./FormErrors.vue?vue&type=script&lang=js"
export * from "./FormErrors.vue?vue&type=script&lang=js"
import style0 from "./FormErrors.vue?vue&type=style&index=0&id=6b366b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b366b24",
  null
  
)

export default component.exports